import { PermissionT } from "../types";

export const createOffers = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "create_offers");
  return !!p;
};

export default createOffers;
